import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ToolComponent } from '@igo2/common/tool';
import { LanguageService } from '@igo2/core/language';
import { DroitsContraintesComponent } from './droits-contraintes/droits-contraintes.component';
import { TransactionsAmendementsComponent } from './transactions-amendements/transactions-amendements.component';
import { TransfertAutoriteComponent } from './transfert-autorite/transfert-autorite.component';
import { RechercheRdeService } from 'src/app/shared/services/recherche-rde.service';
import { WorkspaceState } from '@igo2/integration';
import { Layer, StyleModalLayerButtonComponent } from '@igo2/geo';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

type RdeResult = {
  typeRecherche: string;
  nomCouche: string;
  idCouche: string;
  layer: Layer;
};

@ToolComponent({
  name: 'sigt-recherche-rde',
  title: 'igo.integration.tools.sigtRechercheRde',
  icon: {
    name: 'recherche-rde',
    svg: `
      <svg id="recherche-rde" viewBox="0 0 24 24">
        <path d="M 10.443 1.087 C 12.423 1.087 14.028 2.692 14.028 4.671 C 14.028 5.559 13.703 6.376 13.168 7.003 L 13.318 7.152 L 13.753 7.152 L 16.509 9.909 L 15.682 10.737 L 12.925 7.98 L 12.925 7.545 L 12.776 7.395 C 12.148 7.93 11.332 8.255 10.443 8.255 C 8.465 8.255 6.86 6.651 6.86 4.671 C 6.86 2.692 8.465 1.087 10.443 1.087 M 10.443 2.19 C 9.065 2.19 7.962 3.293 7.962 4.671 C 7.962 6.049 9.065 7.152 10.443 7.152 C 11.822 7.152 12.925 6.049 12.925 4.671 C 12.925 3.293 11.822 2.19 10.443 2.19 Z" style="transform-box: fill-box; transform-origin: 50% 50%;"/>
        <text style="font-family: Roboto, sans-serif; font-size: 9.8px; white-space: pre;" x="2.735" y="22.495"><title>RDE</title>RDE</text>
      </svg>`
  }
})

@Component({
    selector: 'app-sigt-recherche-rde',
    templateUrl: './sigt-recherche-rde.component.html',
    styleUrls: ['./sigt-recherche-rde.component.scss'],
    imports: [
        TranslateModule,
        CommonModule,
        MatRadioModule,
        MatDividerModule,
        MatTableModule,
        MatCheckboxModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTooltipModule,
        MatIconModule,
        DroitsContraintesComponent,
        TransactionsAmendementsComponent,
        TransfertAutoriteComponent
    ]
})
export class SigtRechercheRdeComponent implements OnInit {
  sections = [];
  sectionSelectionnee = 0;
  rdeSearchChoice: string = '';
  rdeLayersInfo: BehaviorSubject<any> = new BehaviorSubject(null);

  colonnesTableResultats = ['select', 'nomCouche', 'grille'];
  rdeResults: RdeResult[] = [];
  resultatsTableDataSource = new MatTableDataSource<RdeResult>(this.rdeResults);
  selection = new SelectionModel<RdeResult>(true, []);

  constructor(
    private languageService: LanguageService,
    private workspaceState: WorkspaceState,
    private rechercheRdeService: RechercheRdeService
  ) { 
    rechercheRdeService.layers$.subscribe(results => {
      this.rdeResults = [];
      this.selection.clear();
      results.forEach(layer => {
        this.rdeResults.push(
          {
            typeRecherche: this.rdeSearchChoice,
            idCouche: layer.options.title,
            nomCouche: layer.options.title,
            layer: layer
          });
      });
      this.resultatsTableDataSource.data = this.rdeResults;
    });

  }

  ngOnInit(): void {
    this.sections = [
      { value: 0, label: this.languageService.translate.instant('sigt.integration.rechercheRde.tabs.droitContraintes') },
      { value: 1, label: this.languageService.translate.instant('sigt.integration.rechercheRde.tabs.transactionsAmendements') },
      { value: 2, label: this.languageService.translate.instant('sigt.integration.rechercheRde.tabs.transfertAutorite') }
    ];
  }

  onSectionChangee($event) {
    this.sectionSelectionnee = $event.value;
  }
    selectRdeSearchChoice(event) {
      this.rdeSearchChoice = event.value as string;
    }
  
    deleteResults() {
      this.selection.selected.forEach(row => {
        this.rechercheRdeService.removeLayer(row.layer);
      });
      this.selection.clear();
    }
  
    toggleAllRows() {
      this.isAllSelected() ?
        this.selection.clear() :
        this.resultatsTableDataSource.data.forEach(row => this.selection.select(row));
    }
  
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.resultatsTableDataSource.data.length;
      return numSelected === numRows;
    }
  
    checkboxLabel(row?: RdeResult): string {
      if (!row) {
        return `${this.isAllSelected() ? 'Déselectionner' : 'Sélectionner'} tout`;
      }
      return `${this.selection.isSelected(row) ? 'Déselectionner' : 'Sélectionner'} résultat ${row.nomCouche}`;
    }
  
    ouvrirGrille(row: RdeResult) {
      if (this.workspaceState.workspace$.value &&
        (this.workspaceState.workspace$.value as any).layer.id === row.layer.id &&
        this.workspaceState.expanded()) {
        this.workspaceState.expanded.set(false);
      } else {
        this.workspaceState.expanded.set(true);
        this.workspaceState.setActiveWorkspaceById(row.layer.id);
      }
    }
}
